/**
 * tabNavigation - Creates a navigation helper for determining active tabs/links
 *
 * @returns {Object} Navigation helper object with methods for checking active states
 */
function tabNavigation() {
    /**
     * Normalizes URL paths by removing trailing slashes (except for root path)
     * @param {string} path - The URL path to normalize
     * @returns {string} Normalized path
     */
    const normalizePath = path => path === '/' ? path : path.replace(/\/$/, '');

    return {
        /**
         * Checks if a link href exactly matches the current path
         * @param {string} href - The href attribute of the link to check
         * @returns {boolean} True if the link matches current location
         */
        isActive(href) {
            // Handle edge cases
            if (!href) return false;

            const currentPath = window.location.pathname;
            return normalizePath(currentPath) === normalizePath(href);
        },

        /**
         * Checks if current path is within the hierarchy of the provided href
         * Useful for expandable menus or breadcrumb navigation
         *
         * @param {string} href - The href attribute to check against
         * @returns {boolean} True if current path starts with the provided href
         */
        isPartiallyActive(href) {
            if (!href) return false;

            const currentPath = window.location.pathname;
            const normalizedCurrentPath = normalizePath(currentPath);
            const normalizedHref = normalizePath(href);

            // Special case for root path
            if (normalizedHref === '/') return normalizedCurrentPath === '/';

            // Check if current path starts with the href path
            return normalizedCurrentPath.startsWith(normalizedHref);
        }
    };
}

// Make available globally for use in inline scripts
if (typeof window !== "undefined") {
  window.tabNavigation = tabNavigation;
}

